import ReactGA from 'react-ga4';

export const setPageTitleAttribute = (pageTitle) => {
  const title = pageTitle.replace(/[^a-zA-Z0-9-_\s]/g, '');
  document.title = `${title} | Optifarm`;
  ReactGA.set({ title: document.title, page: document.title });
};
